// Fatura Tasarım Şablonları (XSLT) penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'documents.xsltTemplates';

export const xsltTemplatesGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Fatura tasarım şablonu nasıl hazırlanır?'),
  intro: t(`${G}.intro`, 'E-faturanızın görünümünü (logo, kaşe, düzen) bu pencereden belirlersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Şablonlar ve görseller'),
    footer: t(`${G}.regions.footer`, 'Kaydet / Kapat'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu pencere ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Varsayılan şablon, e-fatura gönderilirken faturaya gömülür. Hiç şablon yoksa faturalar entegratörün (EDM / PavoPay) hesap tasarımıyla oluşur.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Varsayılandan şablon oluşturun'),
      text: t(`${G}.s2.text`, 'XSLT içeriğini elle düzenlemeniz gerekmez. "Sistem Varsayılanından Oluştur" ile hazır tasarımı kopyalayın, isim verip kaydedin; bu kadarı yeterlidir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Firma / şube logonuz ve entegrasyon ayarında seçtiğiniz banka hesapları gönderim sırasında şablona kendiliğinden eklenir.'),
        t(`${G}.s2.tip2`, 'Elinizde hazır bir dosya varsa "Dosyadan Yükle (.xslt)" ile yükleyebilirsiniz.'),
        t(`${G}.s2.tip3`, '"Sistem Varsayılanını Önizle" hazır tasarımın nasıl göründüğünü gösterir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Logo ve kaşe / imza ekleyin'),
      text: t(`${G}.s3.text`, 'Fatura Görselleri bölümünde logo faturanın üstünde, kaşe / imza altta sağda gösterilir. "Kütüphaneden Seç" veya "Bilgisayardan Yükle" (PNG / JPG) ile ekleyin, "Kaldır" ile silin.'),
      tips: [
        t(`${G}.s3.tip1`, 'Kapsam: "Şirket Geneli" tüm faturalarda kullanılır; bir şube seçerseniz o şubenin faturalarında şirketinki yerine o görsel kullanılır.'),
        t(`${G}.s3.tip2`, 'Öncelik sırası: tasarıma özel görsel → şube görseli → şirket görseli.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Şablon ayarlarını yapın'),
      text: t(`${G}.s4.text`, 'Şablonu oluşturunca veya kalem simgesiyle açınca Şablon Adı (zorunlu), Belge Türü (Hepsi, Sadece E-Fatura, Sadece E-Arşiv), Kapsam ve "Varsayılan şablon" anahtarı görünür.'),
      tips: [
        t(`${G}.s4.tip1`, 'Şubeye özel şablon, o şubede şirket geneli şablonun yerine geçer.'),
        t(`${G}.s4.tip2`, '"Bu Tasarıma Özel Görseller": aynı vergi numarası altında farklı markalar için şablona özel logo / kaşe; boş bırakılırsa şube / şirket görseli kullanılır.'),
        t(`${G}.s4.tip3`, 'XSLT İçeriği alanı yalnız ileri düzey özelleştirme içindir; boş bırakılamaz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Listeyi yönetin ve önizleyin'),
      text: t(`${G}.s5.text`, 'Kayıtlı şablonlar listede belge türü ve kapsam etiketleriyle görünür. Yıldız simgesi şablonu varsayılan yapar (gönderimde kendiliğinden kullanılır). Göz simgesiyle şablonu kayıtlı bir faturanızla önizleyebilirsiniz; önizlemede gönderim yapılmaz.'),
      tips: [
        t(`${G}.s5.tip1`, 'Kalem simgesi şablonu düzenler, çöp kutusu onay sorduktan sonra siler.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Kaydedin'),
      text: t(`${G}.s6.text`, 'Düzenleme ekranında "Kaydet" şablonu kaydeder, "Geri" listeye döner. Liste ekranında "Kapat" pencereyi kapatır. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
